// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M8,6 C8.58333625,6 9.06249812,6.18749813 9.4375,6.5625 C9.81250188,
				6.93750188 10,7.41666375 10,8 C10,8.58333625 9.81250188,9.06249812 9.4375,
				9.4375 C9.06249812,9.81250187 8.58333625,10 8,10 C7.41666375,10 6.93750187,
				9.81250187 6.5625,9.4375 C6.18749812,9.06249812 6,8.58333625 6,8 C6,7.41666375
				6.18749812,6.93750188 6.5625,6.5625 C6.93750187,6.18749813 7.41666375,6 8,6
				Z M2,6 C2.58333625,6 3.06249812,6.18749813 3.4375,6.5625 C3.81250188,
				6.93750188 4,7.41666375 4,8 C4,8.58333625 3.81250188,9.06249812 3.4375,
				9.4375 C3.06249812,9.81250187 2.58333625,10 2,10 C1.41666375,10 0.937501875,
				9.81250187 0.5625,9.4375 C0.187498125,9.06249812 0,8.58333625 0,8 C0,
				7.41666375 0.187498125,6.93750188 0.5625,6.5625 C0.937501875,6.18749813
				1.41666375,6 2,6 Z M14,6 C14.5833362,6 15.0624981,6.18749813 15.4375,
				6.5625 C15.8125019,6.93750188 16,7.41666375 16,8 C16,8.58333625 15.8125019,
				9.06249812 15.4375,9.4375 C15.0624981,9.81250187 14.5833362,10 14,10 C13.4166637,
				10 12.9375019,9.81250187 12.5625,9.4375 C12.1874981,9.06249812 12,8.58333625 12,
				8 C12,7.41666375 12.1874981,6.93750188 12.5625,6.5625 C12.9375019,6.18749813
				13.4166637,6 14,6 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/More.js